import { Box, Typography } from '@mui/material';
import ProgressRing from '@core/components/ui/ProgressRing';
import { toProperCase } from '@core/utils/string';
import type { Order } from '../../api/order';
import { ORDER_STATUS_PALETTE, OrderStatus } from '../enum/orderStatus';
import { getOrderProgressPercent } from '../utils/order';
import OrderListCell from './OrderListCell';

interface OrderStatusCellProps {
  order: Order;
}

const OrderStatusCell = ({ order }: OrderStatusCellProps) => {
  const percent = getOrderProgressPercent(order);
  const palette = ORDER_STATUS_PALETTE[order.status];
  const textColor = `${palette}.800`;
  const trackColor =
    order.status === OrderStatus.ReadyForProduction
      ? `${ORDER_STATUS_PALETTE[OrderStatus.InProduction]}.200`
      : `${palette}.200`;
  const ringColor =
    order.status === OrderStatus.ReadyForRelease
      ? `${ORDER_STATUS_PALETTE[OrderStatus.Released]}.800`
      : textColor;
  return (
    <OrderListCell>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minWidth: 0,
          width: '100%',
        }}
      >
        <ProgressRing
          value={percent}
          color={ringColor}
          trackColor={trackColor}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" noWrap sx={{ color: textColor }}>
            {toProperCase(order.status)}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ display: 'block' }}
          >
            {percent}% completed
          </Typography>
        </Box>
      </Box>
    </OrderListCell>
  );
};

export default OrderStatusCell;
